import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { Section } from '@ugu/types'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

/**
 * Delete course section
 * @param course_id
 * @param version
 * @param section_id
 */
const deleteCourseSection = (
  course_id: string,
  version: number,
  section_id: string
): Promise<Section> => {
  return new Promise((resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const URL =
      routes.COURSE + course_id + '/' + version + '/sections/' + section_id
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
    }
    AxiosClient.delete(URL, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default deleteCourseSection
